import { Box, Button, Grid, TextField, Typography, Backdrop, CircularProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { cfpBaseUrl } from '../../../../network/urls';
import { allCompaniesAPI } from '../../../../services/Functions';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SupportCenterUpdateForm = () => {

  const initialValues = {
    iv_name: '',
    iv_code: '',
    iv_company_code: '',
    iv_circle_code: '',
    iv_division_code: '',
    iv_address: '',
    iv_phone_no: '',
    iv_email: '',
    iv_assign_admin: '',
    iv_add_staffmember: '',
    iv_status: "active"
  }

  const { state } = useLocation();
  const { cfcToEdit } = state;
  const [cfcState, setCfcState] = useState()
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const navigate = useNavigate();

  const { token, code: userOfficeCode } = useSelector((state) => state.auth);

  // Formik form submission and new connection API calling
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: Yup.object({
        iv_name: Yup.string().required("Please enter Name"),
        iv_code: Yup.string().optional("Please enter Code."),
        iv_company_code: Yup.mixed().optional("Please select Company"),
        iv_circle_code: Yup.mixed().required("Please select Circle"),
        iv_division_code: Yup.mixed().required("Please select Division"),
        iv_address: Yup.string().required("Please enter Address."),
        iv_phone_no: Yup.string().min(11, "Phone No. should be 11 digits").max(11, "Phone No. shoud be 10 digits").required("Please enter Phone No."),
        iv_email: Yup.string().email("Please enter valid Email.").required("Please enter Email."),
        iv_status: Yup.string().required('Select status')
      }),

      onSubmit: async (values, { resetForm }) => {

        var formdata = new FormData();
        formdata.append("cfcId", values.iv_code);
        formdata.append("cfcName", values.iv_name);
        formdata.append("address", values.iv_address);
        formdata.append("phoneNo", values.iv_phone_no);
        formdata.append("currentStatus", values.iv_status);
        formdata.append("email", values.iv_email);
        formdata.append("statusremarks", "");
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/updateCFC", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === '200') {
              navigate('/support-center-management')
            } else {
            }
          })
          .catch(error => console.log('error', error));
      }
    })

  useEffect(() => {
    const callAllCompanies = async () => {
      setViewBackdrop(true)
      let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
      if (companiesList) {
        companiesList = companiesList.filter(item => item.companyCode != 1)
        let cpList = companiesList.map(item => ({
          code: item.companyCode,
          name: item.companyName
        }))
        setCompanyList(cpList)
      }
      setViewBackdrop(false);
    }
    callAllCompanies()
  }, [])

  useEffect(() => {
    if (userOfficeCode != 10) {
      values.iv_company_code = parseInt(userOfficeCode.toString().slice(0, 2))
    }
  }, [])

  useEffect(() => {
    setCfcState(cfcToEdit)
  }, [cfcToEdit])

  useEffect(() => {
    if (cfcState) {
      values.iv_company_code = cfcState.companyCode
      values.iv_circle_code = cfcState.circleCode
      values.iv_division_code = cfcState.divisionCode
      values.iv_name = cfcState.cfcName
      values.iv_code = cfcState.cfcId
      values.iv_address = cfcState.address
      values.iv_phone_no = cfcState.phoneNo
      values.iv_email = cfcState.email
    }
  }, [cfcState])

  useEffect(() => {
    if (values.iv_company_code) {
      const callAllCirclesAPI = async () => {
        setViewBackdrop(true)
        const formdata = new FormData();

        formdata.append("companyCode", values.iv_company_code);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        const requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow"
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/getCirclesDetails", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              let cirList = result.data.map(item => ({
                name: item.circleName,
                code: item.circleCode
              }))
              setCircleList(cirList);
            }
          })
          .catch((error) => console.error(error));
        setViewBackdrop(false)
      }
      callAllCirclesAPI()
    }
  }, [values.iv_company_code])

  useEffect(() => {
    if (values.iv_circle_code) {
      const callAllDivisionsAPI = async () => {
        setViewBackdrop(true)
        const formdata = new FormData();

        formdata.append("circleCode", values.iv_circle_code);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        const requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow"
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/getDivisionDetails", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              let divList = result.data.map(item => ({
                name: item.divisionName,
                code: item.divisionCode
              }))
              setDivisionList(divList);
            }
          })
          .catch((error) => console.error(error));
        setViewBackdrop(false)
      }
      callAllDivisionsAPI()
    }
  }, [values.iv_circle_code && circleList])

  return (
    <>
      <Grid container className='form-box' sx={{ marginLeft: '30px', marginRight: '30px' }}>
        <Grid item lg={12}>
          <h3>
            Update Support Center
          </h3>
        </Grid>
        <Grid item lg={12} sx={{ margin: '15px 0px' }}>
          <Grid container sx={{ backgroundColor: 'white', borderRadius: '10px', border: '1px solid lightgrey', padding: '10px', minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
            <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px 20px', padding: '5px' }}>
              <h4 style={{ color: '#006ad1' }}>
                Location
              </h4>
            </Grid>
            <Grid item lg={12}>
              <Grid container sx={{ padding: '0px 10px' }}>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel' >Company</Typography>
                  <Select
                    fullWidth
                    value={values.iv_company_code?values.iv_company_code:'-'}
                    disabled
                    sx={{ height: '45px' }}
                    className='dropdownList'
                    name="iv_company_code"
                    id="iv_company_code"
                  >
                    <MenuItem value='' >Select Company</MenuItem>
                    {
                      companyList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                    }
                  </Select>
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_company_code && touched.iv_company_code ? (errors.iv_company_code) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel' >Circle</Typography>
                  <Select
                    fullWidth
                    value={values.iv_circle_code?values.iv_circle_code:'-'}
                    disabled
                    displayEmpty
                    sx={{ height: '45px' }}
                    className='dropdownList'
                    name='iv_circle_code'
                    id="select"
                  >
                    <MenuItem value="">Select Circle</MenuItem>
                    {
                      circleList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                    }
                  </Select>
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_circle_code && touched.iv_circle_code ? (errors.iv_circle_code) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel' >Division</Typography>
                  <Select
                    fullWidth
                    value={values.iv_division_code?values.iv_division_code:'-'}
                    disabled
                    displayEmpty
                    sx={{ height: '45px' }}
                    className='dropdownList'
                    name='iv_division_code'
                  >
                    <MenuItem value=''>Select Division</MenuItem>
                    {
                      divisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                    }
                  </Select>
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_division_code && touched.iv_division_code ? (errors.iv_division_code) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'>Name</Typography>
                  < TextField name='iv_name'
                    required
                    type='text'
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                    value={values.iv_name?values.iv_name:'-'}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    className='textInputField' />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }} >
                    {errors.iv_name && touched.iv_name ? (errors.iv_name) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel' >Office code</Typography>
                  <TextField
                    required
                    type='double'
                    name="iv_code"
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                    disabled
                    value={values.iv_code?values.iv_code:'-'}
                    onBlur={handleBlur}
                    id="iv_code"
                    className='textInputField'
                  />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_code && touched.iv_code ? (errors.iv_code) : null}
                  </Box>
                </Grid>
                <Grid item xs={9} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'  >Address</Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_address"
                    fullWidth
                    value={values.iv_address?values.iv_address:'-'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                  />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_address && touched.iv_address ? (errors.iv_address) : null}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px 20px', padding: '5px' }}>
              <h4 style={{ color: '#006ad1' }}>
                Contact
              </h4>
            </Grid>
            <Grid item lg={12}>
              <Grid container sx={{ padding: '0px 10px' }}>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'>Phone No.</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_phone_no"
                    inputProps={{ maxLength: 11 }}
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                    value={values.iv_phone_no?values.iv_phone_no:'-'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField' />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }} >
                    {errors.iv_phone_no && touched.iv_phone_no ? (errors.iv_phone_no) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'  >Email</Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_email"
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                    value={values.iv_email?values.iv_email:'-'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                  />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_email && touched.iv_email ? (errors.iv_email) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <FormControl>
                    <Typography className='fieldLabel'>Status</Typography>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={values.iv_status}
                      onChange={handleChange}>
                      <FormControlLabel value={"active"} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label="Active" />
                      <FormControlLabel value={"inactive"} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label="Inactive" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} sx={{ padding: '0px 10px', minHeight: '20vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
              <Button sx={{ width: '10%' }} variant="contained" size='medium' onClick={handleSubmit}>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >
    </>
  );
}

export default SupportCenterUpdateForm;